module.exports = __webpack_public_path__ + "7f43bfdd35aecd546a0e4d41f75ab139.svg";